import {Pipe, PipeTransform} from '@angular/core';
import {DatePipe} from '@angular/common';
import * as moment from 'moment';

@Pipe({
  name: 'dateFormat'
})
export class DateFormatPipe implements PipeTransform {

  transform(value: any, args: string = 'MM/DD/YYYY HH:MM'): string {

    const isoRegex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{6}Z$/;
    if (isoRegex.test(value)) {
      return moment(value, 'YYYY-MM-DDTHH:mm:ssZ').utc().local().format('MM/DD/YYYY hh:mm A');
    }

    return moment.unix(value).utc().local().format('MM/DD/YYYY hh:mm A');
  }

}
